import type { PromptCampaignType } from "@repo/components/src/shared/agent/campaignTypeFromPrompt";
import { AgentKey } from "@repo/graphql/gql/graphql";

/**
 * Stable, URL-safe identifier for a campaign type. Unlike `label`, this never
 * changes with copy — deep links (e.g. the dashboard's Montu AI launcher)
 * carry this in `?type=` and resolve it back to an `agentKey` here. The same set
 * `campaignTypeFromPrompt` reads out of a launcher's free text.
 */
export type CampaignTypeSlug = PromptCampaignType;

/**
 * The three kinds of campaign, and the agent that builds each one.
 *
 * This lives on the client on purpose. The type is the one thing that has to be
 * settled before the chat can open — it decides which agent runs, what formats exist,
 * and what the Brief card asks — so it is a click, not something to ask the model.
 */
export type CampaignTypeOption = {
  slug: CampaignTypeSlug;
  agentKey: AgentKey;
  label: string;
  /** What the creator actually produces. The distinction people get wrong. */
  detail: string;
  description: string;
};

export const CAMPAIGN_TYPES: CampaignTypeOption[] = [
  {
    slug: "ugc",
    agentKey: AgentKey.CampaignCreatorUgc,
    label: "UGC Ads",
    detail: "Anuncios",
    description:
      "El creador graba, tú pautas. No se publica en su perfil: son piezas para tus anuncios.",
  },
  {
    slug: "organic",
    agentKey: AgentKey.CampaignCreatorOrganic,
    label: "Orgánica",
    detail: "Stories, reels, feed, TikTok",
    description: "El creador publica en su propio perfil, ante su audiencia.",
  },
  {
    slug: "meliclips",
    agentKey: AgentKey.CampaignCreatorMeliclips,
    label: "MeliClips",
    detail: "Mercado Libre",
    description:
      "Videos cortos en la ficha de tu producto, al lado del botón de comprar.",
  },
];
